
export function enablePageviewInstrumentation (router, probe) {
  router.afterEach((to, from ) => {
    probe.pageview(to.name, to.path, to.query);
  });
}
